import { useEffect, type ReactNode } from 'react'
import { useApp } from './useApp'

function setFavicon(url: string | null): void {
  const selector = 'link[rel="icon"], link[rel="shortcut icon"]'
  let link = document.head.querySelector<HTMLLinkElement>(selector)
  if (!url) {
    link?.removeAttribute('href')
    return
  }
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.href = url
}

export function OrganizationBrandProvider({ children }: { readonly children: ReactNode }) {
  const { currentOrganization } = useApp()

  useEffect(() => {
    setFavicon(currentOrganization?.faviconUrl ?? currentOrganization?.logoUrl ?? null)
  }, [currentOrganization?.faviconUrl, currentOrganization?.logoUrl])

  return <>{children}</>
}